<template>
  <div class="container">
    <iframe class="hide-scrollbar" :srcdoc="srcdoc" style="width: 100%;border: none;height: 100%"></iframe>
  </div>
</template>

<script>


export default {
  name: "Test",
  data() {
    return {
      srcdoc: `1123123`
    }
  },
  mounted() {

  }
}
</script>

<style scoped>

</style>
